import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '874982625170304';
/**
 * Loads the Meta (Facebook) Pixel base code and fires a PageView once
 * when the page mounts. Made resilient to a document that may not yet
 * contain any <script> element (which is the case inside the preview
 * iframe and was causing "Cannot read properties of undefined (reading
 * 'parentNode')").
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    const d = document;
    if (!w.fbq) {
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Inject the loader without relying on an existing <script> node.
      const t = d.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = d.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(t, firstScript);
      } else {
        ;
        (d.head || d.body || d.documentElement).appendChild(t);
      }
    }
    if (w.fbq) {
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-190">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-191" />
    </noscript>;
}